import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "X denunciou uma mensagem em #canal." Vai para os moderadores.
 *
 * O clique leva à fila, e não à mensagem: lá estão o texto da denúncia e as ações.
 */
export default class MessageFlaggedNotification extends Notification {
  icon() {
    return 'fas fa-flag';
  }
  href() {
    return app.route('chat.flags');
  }
  content() {
    var _this$data$channelNam;
    const reporter = this.attrs.notification.fromUser();
    return app.translator.trans('ramon-chat.forum.notifications.message_flagged', {
      username: reporter ? reporter.displayName() : app.translator.trans('ramon-chat.forum.notifications.someone', {}, true),
      channel: (_this$data$channelNam = this.data().channelName) != null ? _this$data$channelNam : ''
    });
  }

  /**
   * Mostra o motivo, não o texto denunciado: os dados da notificação voltam sem
   * nova checagem de permissão, e uma mensagem ocultada depois ainda apareceria
   * aqui (ver MessageFlaggedBlueprint).
   */
  excerpt() {
    const reason = this.data().reason;
    if (!reason) return null;
    return app.translator.trans("ramon-chat.forum.flag.reasons.".concat(reason));
  }
  data() {
    var _ref;
    return (_ref = this.attrs.notification.content()) != null ? _ref : {};
  }
}
flarum.reg.add('ramon-chat', 'forum/components/MessageFlaggedNotification', MessageFlaggedNotification);